import { ChangeEvent, useEffect, useState } from "react";
import { useUpdate } from "./service";
import useAlertStore from "store/alert";
import useModalStore from "store/modal";
import { upInfProps } from "./detail";
import { useManagerDetailContext } from "./context";

// 매니저 정보 change
export const useChange = () => {
  const { isSuccess } = useManagerDetailContext();
  const [upInf, setUpInf] = useState<upInfProps>({
    mobNo: undefined,
    mobCntyCd: undefined,
    uYn: undefined,
  });

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setUpInf({
      ...upInf,
      mobNo: e.currentTarget.value,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      setUpInf({
        mobNo: undefined,
        mobCntyCd: undefined,
        uYn: undefined,
      });
    }
  }, [isSuccess]);

  return {
    upInf,
    onChange,
  };
};

type IProps = {
  upInf: upInfProps;
  manNo: string | undefined;
};
// 매니저 정보 수정
export const useOnUpdate = ({ upInf, manNo }: IProps) => {
  const { mutate } = useUpdate();
  //   const { upInf } = useChange();
  const [isAble, setIsAble] = useState(false); // 수정가능 여부
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const setTitle = useModalStore((state) => state.setTitle);

  const onUpdate = () => {
    if (!isAble) {
      setIsAble(true);
      setTitle("매니저 수정");
    }
    if (isAble) {
      // 수정 내용 여부 확인

      const isUpdateAble = Object.values(upInf).some(
        (value) => value !== "" && value !== undefined && value !== null
      );

      if (!isUpdateAble) {
        onSetAlert({
          isOpen: true,
          inner: "수정된 내용이 없습니다.",
        });
      }
      if (isUpdateAble) {
        // 수정 진행
        onSetAlert({
          isOpen: true,
          inner: "매니저정보를 수정하시겠습니까?",
          cnclBtn: true,
          onSetConfirm: () => {
            // 수정 내용 수정 진행
            mutate({
              ...upInf,
              manNo: manNo ?? "",
            });
          },
        });
      }
    }
  };

  return {
    isAble,
    onUpdate,
  };
};
